import { HTTP } from '@/api/http-common'
import { HttpFunctions } from '@/api/http-functions'

export default {
  getCcEmail (callback) {
    HTTP.get('emails').then(response => {
      if (response.status === 200) {
        callback(response)
      } else if (response.status === 403) {
        console.log('Error: pdo error missing')
      } else if (response.status === 401) {
        HttpFunctions.response401()
      }
    }).catch(e => {
      console.log(e)
    })
  },
  setCcEmail (callback, param) {
    if (param !== undefined) {
      HTTP.put('emails', param).then(response => {
        if (response.status === 201) {
          callback(response)
        } else if (response.status === 403) {
          console.log('Error: pdo error missing')
        } else if (response.status === 401) {
          HttpFunctions.response401()
        }
      }).catch(e => {
        console.log(e)
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/cc_emails/index.js